module.exports = __webpack_public_path__ + "img/dummyprod6@2x.9c3411a8.png";